<template>
  <div class="fof">
    <div>
      <h1>Uh oh...</h1>
      <h2>You've stumbled into our hiding place...but sadly, nothing's here...</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "FourOhFour"
};
</script>

<style scoped>
.fof {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  padding: 10px;
}

h1 {
  font-family: "OpticianSans", sans-serif;
  font-size: 10vw;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

h2 {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 5vw;
  font-weight: 300;
  margin-bottom: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/FourOhFour.vue